import * as React from "react"

export const CodeOffIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    fill="none"
    viewBox="0 0 40 40"
    {...props}
  >
    <path
      fill="currentColor"
      d="m6.902 20.464 7.186 7.186q.3.3.309.729a1 1 0 0 1-.31.745 1.02 1.02 0 0 1-.745.317 1.02 1.02 0 0 1-.746-.317l-7.772-7.755a1.3 1.3 0 0 1-.294-.427 1.3 1.3 0 0 1-.088-.487q0-.256.088-.476a1.4 1.4 0 0 1 .294-.437l5.614-5.615L4.291 7.78a1.04 1.04 0 0 1-.318-.742q-.008-.432.318-.758.315-.315.744-.315.43 0 .756.315l28.43 28.43q.298.309.306.734a.98.98 0 0 1-.307.74 1.04 1.04 0 0 1-.755.326q-.43 0-.745-.326L11.938 15.427zm23.203 5.987-1.5-1.5 4.493-4.494-7.186-7.196a1 1 0 0 1-.3-.73q0-.428.318-.734a1.02 1.02 0 0 1 .745-.317q.429 0 .746.317l7.755 7.745q.206.216.3.437.092.22.092.476 0 .267-.093.487a1.4 1.4 0 0 1-.299.427z"
    ></path>
  </svg>
)
